class PropertyDeveloper {
    id;
    name;
    description;
    websiteLink;
    photoURL;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.description = data.description;
        this.websiteLink = data.websiteLink;
        this.photoURL = data.photoURL;
    }
}
export default PropertyDeveloper;
